// components/class-config/classGroups.js

export const classGroups = {
  bg_color: {
    label: "Background Color",
    options: {
      transparent: [{ name: "Transparent", class: "z-bg-transparent", description: "" }],
      primary: [
        { name: "Primary/100", class: "z-bg-primary-100", description: "" },
        { name: "Primary/200", class: "z-bg-primary-200", description: "" },
        { name: "Primary/300", class: "z-bg-primary-300", description: "" },
        { name: "Primary/400", class: "z-bg-primary-400", description: "" }
      ],
      secondary: [
        { name: "Secondary/100", class: "z-bg-secondary-100", description: "" },
        { name: "Secondary/200", class: "z-bg-secondary-200", description: "" },
        { name: "Secondary/300", class: "z-bg-secondary-300", description: "" },
        { name: "Secondary/400", class: "z-bg-secondary-400", description: "" }
      ],
      gradient: [
        { name: "Gradient 1", class: "z-bg-gradient-1", description: "" },
        { name: "Gradient 2", class: "z-bg-gradient-2", description: "" },
        { name: "Gradient 3", class: "z-bg-gradient-3", description: "" },
        { name: "Gradient 4", class: "z-bg-gradient-4", description: "" }
      ],
      neutral: [
        { name: "Neutral/100", class: "z-bg-neutral-100", description: "" },
        { name: "Neutral/200", class: "z-bg-neutral-200", description: "" },
        { name: "Neutral/300", class: "z-bg-neutral-300", description: "" },
        { name: "Neutral/400", class: "z-bg-neutral-400", description: "" },
        { name: "Neutral/500", class: "z-bg-neutral-500", description: "" },
        { name: "Neutral/600", class: "z-bg-neutral-600", description: "" },
        { name: "Neutral/700", class: "z-bg-neutral-700", description: "" },
        { name: "Neutral/800", class: "z-bg-neutral-800", description: "" },
        { name: "Neutral/900", class: "z-bg-neutral-900", description: "" },
        { name: "Neutral/1000", class: "z-bg-neutral-1000", description: "" }
      ],
      danger: [
        { name: "Danger/100", class: "z-bg-danger-100", description: "" },
        { name: "Danger/200", class: "z-bg-danger-200", description: "" },
        { name: "Danger/300", class: "z-bg-danger-300", description: "" },
        { name: "Danger/400", class: "z-bg-danger-400", description: "" }
      ],
      warning: [
        { name: "Warning/100", class: "z-bg-warning-100", description: "" },
        { name: "Warning/200", class: "z-bg-warning-200", description: "" },
        { name: "Warning/300", class: "z-bg-warning-300", description: "" },
        { name: "Warning/400", class: "z-bg-warning-400", description: "" }
      ],
      success: [
        { name: "Success/100", class: "z-bg-success-100", description: "" },
        { name: "Success/200", class: "z-bg-success-200", description: "" },
        { name: "Success/300", class: "z-bg-success-300", description: "" },
        { name: "Success/400", class: "z-bg-success-400", description: "" }
      ]
    }
  },
  text_color: {
    label: "Text Color",
    options: {
      transparent: [{ name: "Transparent", class: "z-text-transparent", description: "" }],
      primary: [
        { name: "Primary/100", class: "z-text-primary-100", description: "" },
        { name: "Primary/200", class: "z-text-primary-200", description: "" },
        { name: "Primary/300", class: "z-text-primary-300", description: "" },
        { name: "Primary/400", class: "z-text-primary-400", description: "" }
      ],
      secondary: [
        { name: "Secondary/100", class: "z-text-secondary-100", description: "" },
        { name: "Secondary/200", class: "z-text-secondary-200", description: "" },
        { name: "Secondary/300", class: "z-text-secondary-300", description: "" },
        { name: "Secondary/400", class: "z-text-secondary-400", description: "" }
      ],
      neutral: [
        { name: "Neutral/100", class: "z-text-neutral-100", description: "" },
        { name: "Neutral/200", class: "z-text-neutral-200", description: "" },
        { name: "Neutral/300", class: "z-text-neutral-300", description: "" },
        { name: "Neutral/400", class: "z-text-neutral-400", description: "" },
        { name: "Neutral/500", class: "z-text-neutral-500", description: "" },
        { name: "Neutral/600", class: "z-text-neutral-600", description: "" },
        { name: "Neutral/700", class: "z-text-neutral-700", description: "" },
        { name: "Neutral/800", class: "z-text-neutral-800", description: "" },
        { name: "Neutral/900", class: "z-text-neutral-900", description: "" },
        { name: "Neutral/1000", class: "z-text-neutral-1000", description: "" }
      ],
      danger: [
        { name: "Danger/100", class: "z-text-danger-100", description: "" },
        { name: "Danger/200", class: "z-text-danger-200", description: "" },
        { name: "Danger/300", class: "z-text-danger-300", description: "" },
        { name: "Danger/400", class: "z-text-danger-400", description: "" }
      ],
      warning: [
        { name: "Warning/100", class: "z-text-warning-100", description: "" },
        { name: "Warning/200", class: "z-text-warning-200", description: "" },
        { name: "Warning/300", class: "z-text-warning-300", description: "" },
        { name: "Warning/400", class: "z-text-warning-400", description: "" }
      ],
      success: [
        { name: "Success/100", class: "z-text-success-100", description: "" },
        { name: "Success/200", class: "z-text-success-200", description: "" },
        { name: "Success/300", class: "z-text-success-300", description: "" },
        { name: "Success/400", class: "z-text-success-400", description: "" }
      ]
    }
  },
  text_weight: {
    label: "Text Weight",
    options: {
      default: [
        { name: "None", class: "z-font-weight-light", description: "Light" },
        { name: "Small", class: "z-font-weight-regular", description: "Regular" },
        { name: "Medium", class: "z-font-weight-medium", description: "Medium" },
        { name: "Large", class: "z-font-weight-semibold", description: "Semi Bold" },
        { name: "Extra", class: "z-font-weight-bold", description: "Bold" }
      ]
    }
  },
  text_decoration: {
    label: "Text Decoration",
    options: {
      default: [
        { name: "Underline", class: "z-text-underline", description: "Underline" },
        { name: "Overline", class: "z-text-overline", description: "Overline" },
        { name: "Line Through", class: "z-text-line-through", description: "Line Through" },
        { name: "No Decoration", class: "z-text-no-decoration", description: "No Decoration" }
      ]
    }
  },
  font_size: {
    label: "Font Size",
    options: {
      default: [
        { name: "Extra Small", class: "z-font-xs", description: "12px" },
        { name: "Small", class: "z-font-sm", description: "14px" },
        { name: "Medium", class: "z-font-md", description: "16px" },
        { name: "Large", class: "z-font-lg", description: "20px" },
        { name: "Extra Large", class: "z-font-xl", description: "24px" }
      ],
      "3x": [
        { name: "Extra Small", class: "z-font-3xs", description: "24px" },
        { name: "Small", class: "z-font-3sm", description: "36px" },
        { name: "Medium", class: "z-font-3md", description: "42px" },
        { name: "Large", class: "z-font-3lg", description: "48px" },
        { name: "Extra Large", class: "z-font-3xl", description: "60px" }
      ]
    }
  },
  text_align_horizontal: {
    label: "Horizontal",
    options: {
      default: [
        { name: "Left", class: "z-flex-left", description: "Left" },
        { name: "Center", class: "z-flex-center", description: "Center" },
        { name: "Right", class: "z-flex-right", description: "Right" }
      ]
    }
  },
  text_align_vertical: {
    label: "Vertical",
    options: {
      default: [
        { name: "Top", class: "z-flex-top", description: "Top" },
        { name: "Center", class: "z-flex-vertical-center", description: "Center" },
        { name: "Bottom", class: "z-flex-bottom", description: "Bottom" }
      ]
    }
  },
  border_size: {
    label: "Border Size",
    options: {
      default: [
        { name: "Small", class: "z-border-size-sm", description: "1px" },
        { name: "Medium", class: "z-border-size-md", description: "2px" },
        { name: "Large", class: "z-border-size-lg", description: "4px" }
      ]
    }
  },
  border_style: {
    label: "Border Style",
    options: {
      default: [
        { name: "Solid", class: "z-border-solid", description: "Solid" },
        { name: "Dotted", class: "z-border-dotted", description: "Dotted" },
        { name: "Dashed", class: "z-border-dashed", description: "Dashed" },
        { name: "Double", class: "z-border-double", description: "Double" }
      ]
    }
  },
  border_radius: {
    label: "Border Radius",
    options: {
      default: [
        { name: "None", class: "z-border-radius-none", description: "0px" },
        { name: "Small", class: "z-border-radius-sm", description: "4px" },
        { name: "Medium", class: "z-border-radius-md", description: "8px" },
        { name: "Large", class: "z-border-radius-lg", description: "16px" },
        { name: "Full", class: "z-border-radius-full", description: "50%" },
        { name: "Pill", class: "z-border-radius-pill", description: "30px" }
      ]
    }
  },
  padding: {
    label: "Padding",
    options: {
      default: [
        { name: "Xsm", class: "z-p-1", description: "4px" },
        { name: "Sm", class: "z-p-2", description: "8px" },
        { name: "Md", class: "z-p-3", description: "16px" },
        { name: "Lg", class: "z-p-4", description: "20px" },
        { name: "Xl", class: "z-p-5", description: "24px" }
      ]
    }
  },
  border_color: {
    label: "Border Color",
    options: {
      transparent: [{ name: "Transparent", class: "z-border-transparent", description: "" }],
      primary: [
        { name: "Primary/100", class: "z-border-primary-100", description: "" },
        { name: "Primary/200", class: "z-border-primary-200", description: "" },
        { name: "Primary/300", class: "z-border-primary-300", description: "" },
        { name: "Primary/400", class: "z-border-primary-400", description: "" }
      ],
      secondary: [
        { name: "Secondary/100", class: "z-border-secondary-100", description: "" },
        { name: "Secondary/200", class: "z-border-secondary-200", description: "" },
        { name: "Secondary/300", class: "z-border-secondary-300", description: "" },
        { name: "Secondary/400", class: "z-border-secondary-400", description: "" }
      ],
      neutral: [
        { name: "Neutral/100", class: "z-border-neutral-100", description: "" },
        { name: "Neutral/200", class: "z-border-neutral-200", description: "" },
        { name: "Neutral/300", class: "z-border-neutral-300", description: "" },
        { name: "Neutral/400", class: "z-border-neutral-400", description: "" },
        { name: "Neutral/500", class: "z-border-neutral-500", description: "" },
        { name: "Neutral/600", class: "z-border-neutral-600", description: "" },
        { name: "Neutral/700", class: "z-border-neutral-700", description: "" },
        { name: "Neutral/800", class: "z-border-neutral-800", description: "" },
        { name: "Neutral/900", class: "z-border-neutral-900", description: "" },
        { name: "Neutral/1000", class: "z-border-neutral-1000", description: "" }
      ],
      danger: [
        { name: "Danger/100", class: "z-border-danger-100", description: "" },
        { name: "Danger/200", class: "z-border-danger-200", description: "" },
        { name: "Danger/300", class: "z-border-danger-300", description: "" },
        { name: "Danger/400", class: "z-border-danger-400", description: "" }
      ],
      warning: [
        { name: "Warning/100", class: "z-border-warning-100", description: "" },
        { name: "Warning/200", class: "z-border-warning-200", description: "" },
        { name: "Warning/300", class: "z-border-warning-300", description: "" },
        { name: "Warning/400", class: "z-border-warning-400", description: "" }
      ],
      success: [
        { name: "Success/100", class: "z-border-success-100", description: "" },
        { name: "Success/200", class: "z-border-success-200", description: "" },
        { name: "Success/300", class: "z-border-success-300", description: "" },
        { name: "Success/400", class: "z-border-success-400", description: "" }
      ]
    }
  },
  icon_size: {
    label: "Icon Size",
    options: {
      default: [
        { name: "Extra Small", class: "z-icon-xs", description: "18px" },
        { name: "Small", class: "z-icon-sm", description: "20px" },
        { name: "Medium", class: "z-icon-md", description: "24px" },
        { name: "Large", class: "z-icon-lg", description: "28px" },
        { name: "Extra Large", class: "z-icon-xl", description: "32px" }
      ]
    }
  },
  icon_fill: {
    label: "Fill",
    options: {
      default: [
        {
          name: "Filled",
          class: "z-material-symbols-fill",
          value: 1,
          description: "Filled icon"
        }
      ]
    }
  },
  icon_weight: {
    label: "Icon Weight",
    options: {
      default: [
        {
          name: "Weight 100",
          class: "z-material-symbols-100",
          value: 100,
          description: "Thin stroke"
        },
        {
          name: "Weight 200",
          class: "z-material-symbols-200",
          value: 200,
          description: "Extra light stroke"
        },
        {
          name: "Weight 300",
          class: "z-material-symbols-300",
          value: 300,
          description: "Light stroke"
        },
        {
          name: "Weight 400",
          class: "z-material-symbols-400",
          value: 400,
          description: "Regular stroke"
        },
        {
          name: "Weight 500",
          class: "z-material-symbols-500",
          value: 500,
          description: "Medium stroke"
        },
        {
          name: "Weight 600",
          class: "z-material-symbols-600",
          value: 600,
          description: "Semi-bold stroke"
        },
        {
          name: "Weight 700",
          class: "z-material-symbols-700",
          value: 700,
          description: "Bold stroke"
        }
      ]
    }
  },
  icon_style: {
    label: "Icon Style",
    options: {
      default: [
        {
          name: "Outlined",
          class: "z-material-symbols-outlined",
          value: "Material Symbols Outlined",
          description: "Thin, outlined icons"
        },
        {
          name: "Rounded",
          class: "z-material-symbols-rounded",
          value: "Material Symbols Rounded",
          description: "Rounded edges for a softer look"
        },
        {
          name: "Sharp",
          class: "z-material-symbols-sharp",
          value: "Material Symbols Sharp",
          description: "Sharp corners for a bold appearance"
        }
      ]
    }
  },
  button: {
    label: "Button",
    options: {
      default: [
        { name: "Primary", class: "z-btn-primary", description: "" },
        { name: "Secondary", class: "z-btn-secondary", description: "" },
        { name: "Outline", class: "z-btn-outline", description: "" },
        { name: "Tertiary", class: "z-btn-tertiary", description: "" },
        { name: "Disabled", class: "z-btn-disabled", description: "" },
        { name: "Success", class: "z-btn-success", description: "" },
        { name: "Danger", class: "z-btn-danger", description: "" }
      ]
    }
  },
  button_circle: {
    label: "Button Circle",
    options: {
      default: [
        { name: "S", class: "z-btn-small-circle", description: "" },
        { name: "M", class: "z-btn-medium-circle", description: "" },
        { name: "L", class: "z-btn-large-circle", description: "" }
      ]
    }
  },
  button_size: {
    label: "Button Size",
    options: {
      default: [
        { name: "Small", class: "z-btn-small", description: "" },
        { name: "Medium", class: "z-btn-medium", description: "" },
        { name: "Large", class: "z-btn-large", description: "" }
      ]
    }
  },
  image_object_fit: {
    label: "Image Object Fit",
    options: {
      default: [
        { name: "Cover", class: "z-img-cover", description: "Cover" },
        { name: "Fill", class: "z-img-fill", description: "Fill" },
        { name: "Contain", class: "z-img-contain", description: "Contain" }
      ]
    }
  },
  shadow: {
    label: "Shadow",
    options: {
      default: [
        { name: "None", class: "z-shadow-none", description: "None" },
        { name: "Small", class: "z-shadow-sm", description: "Small" },
        { name: "Medium", class: "z-shadow-md", description: "Medium" },
        { name: "Large", class: "z-shadow-lg", description: "Large" }
      ]
    }
  },
  table_style: {
    label: "Table Style",
    options: {
      default: [
        { name: "Bordered", class: "z-table-bordered", description: "" },
        { name: "Borderless", class: "z-table-transparent", description: "" },
        { name: "Stripped", class: "z-table-stripped", description: "" }
      ]
    }
  },
  search_box: {
    label: "Search Box",
    options: {
      default: [
        { name: "Small", class: "z-search-box-small", description: "" },
        { name: "Medium", class: "z-search-box-medium", description: "" },
        { name: "Large", class: "z-search-box-large", description: "" }
      ]
    }
  }
};

// class-config/blockClassMap.js

export const blockClassMap = {
  button: ["button", "button_size", "button_circle"],
  dropdown: ["button", "button_size", "button_circle"],
  rv_action_button: ["bg_color", "text_color", "text_weight", "font_size"],
  rv_action_dropdown: ["bg_color", "text_color", "text_weight", "font_size"],
  image: ["border_color", "shadow", "border_size", "border_radius", "border_style", "image_object_fit"],
  separator: ["bg_color"],
  search_box: ["search_box", "bg_color", "border_color", "shadow", "border_size", "border_radius", "border_style"],
  table: [
    "bg_color",
    "bg_opacity",
    "text_color",
    "font_size",
    "text_weight",
    "text_decoration",
    "text_align_horizontal",
    "text_align_vertical",
    "border_color",
    "shadow",
    "border_size",
    "border_radius",
    "border_style",
    "image_object_fit",
    "table_style"
  ],
  section: [
    "bg_color",
    "bg_opacity",
    "text_color",
    "font_size",
    "text_weight",
    "text_decoration",
    "text_align_horizontal",
    "text_align_vertical",
    "border_color",
    "shadow",
    "border_size",
    "border_radius",
    "border_style",
    "image_object_fit"
  ],
  label: [
    "bg_color",
    "bg_opacity",
    "text_color",
    "font_size",
    "text_weight",
    "text_decoration",
    "text_align_horizontal",
    "text_align_vertical",
    "border_color",
    "shadow",
    "border_size",
    "border_radius",
    "border_style",
    "padding"
  ],
  tab: [
    "bg_color",
    "bg_opacity",
    "text_color",
    "font_size",
    "text_weight",
    "text_decoration",
    "text_align_horizontal",
    "text_align_vertical",
    "border_color",
    "shadow",
    "border_size",
    "border_radius",
    "border_style",
    "padding"
  ],
  icon: [
    "bg_color",
    "bg_opacity",
    "text_color",
    "icon_style",
    "icon_size",
    "icon_weight",
    "icon_fill",
    "text_decoration",
    "text_align_horizontal",
    "text_align_vertical",
    "border_color",
    "shadow",
    "border_size",
    "border_radius",
    "border_style",
    "padding"
  ],
  download_file: [
    "bg_color",
    "bg_opacity",
    "text_color",
    "font_size",
    "text_weight",
    "text_decoration",
    "text_align_horizontal",
    "text_align_vertical",
    "border_color",
    "shadow",
    "border_size",
    "border_radius",
    "border_style",
    "padding"
  ],
  rv_table_catalog_toggler: [
    "bg_color",
    "bg_opacity",
    "text_color",
    "font_size",
    "text_weight",
    "text_decoration",
    "text_align_horizontal",
    "text_align_vertical",
    "border_color",
    "shadow",
    "border_size",
    "border_radius",
    "border_style",
    "padding"
  ],
  rv_tab_filters: [
    "bg_color",
    "bg_opacity",
    "text_color",
    "font_size",
    "text_weight",
    "text_decoration",
    "text_align_horizontal",
    "text_align_vertical",
    "border_color",
    "shadow",
    "border_size",
    "border_radius",
    "border_style",
    "padding"
  ],
  rv_table: [
    "bg_color",
    "bg_opacity",
    "text_color",
    "font_size",
    "text_weight",
    "text_decoration",
    "text_align_horizontal",
    "text_align_vertical",
    "border_color",
    "shadow",
    "border_size",
    "border_radius",
    "border_style",
    "padding",
    "image_object_fit",
    "table_style"
  ],
  default: [
    "bg_color",
    "bg_opacity",
    "text_color",
    "font_size",
    "text_weight",
    "text_decoration",
    "text_align_horizontal",
    "text_align_vertical",
    "border_color",
    "shadow",
    "border_size",
    "border_radius",
    "border_style",
    "padding",
    "image_object_fit"
  ]
};
